/** Display-only helpers for inventory rows (no pricing). */

export const normalizeDisplayCardName = (name: string, setNumber?: string | null): string => {
  const raw = String(name ?? '').trim()
  if (!raw) return raw

  if (setNumber) {
    const suffix = ` - ${String(setNumber).trim()}`
    if (suffix.trim().length > 3 && raw.toLowerCase().endsWith(suffix.toLowerCase())) {
      return raw.slice(0, raw.length - suffix.length).trim()
    }
  }

  return raw
}
